import React from 'react';
import { NotesEntityFields } from 'common/graphql/__generated__/NotesEntityFields';
import {
  NoteTravelAuthorizationCreate,
  NoteTravelAuthorizationCreateVariables,
} from 'common/graphql/__generated__/NoteTravelAuthorizationCreate';
import { NotesSectionProps } from 'common/components/NotesSection';
import { GenericNotesSection } from 'common/components/ActionMenu/Notes';

import NOTE_TRAVEL_AUTHORIZATION_CREATE from '../../../../../../graphql/NoteTravelAuthorizationCreate.graphql';

type NotesProps = Pick<NotesSectionProps, 'listRefreshRequest'> & {
  travelAuthorizationId: string;
  data: NotesEntityFields[];
  loading?: boolean;
};

export const Notes: React.FC<NotesProps> = ({
  travelAuthorizationId,
  data,
  loading,
  listRefreshRequest,
}) => {
  return (
    <GenericNotesSection<
      any,
      NoteTravelAuthorizationCreate, // TMutationResult
      NoteTravelAuthorizationCreateVariables // TMutationVariables
    >
      entityId={travelAuthorizationId}
      data={data}
      loading={loading}
      mutationDocument={NOTE_TRAVEL_AUTHORIZATION_CREATE}
      listRefreshRequest={listRefreshRequest}
    />
  );
};
